import * as React from "react"
import styled from "styled-components"
import themeGet from "@styled-system/theme-get"
import { Icon } from "@xingternal/winery-ui/lib/Icon"
import { Text } from "@xingternal/winery-ui/lib/Text"
import { withi18n } from "@/helpers/hoc/withi18n"

const size = 13

const TriggerIcon = styled(Icon).attrs({
  color: "grey600",
  mr: 2,
})``

const Separator = styled.div`
  width: 1px;
  height: 18px;
  margin: 0 ${themeGet("space.2")};
  background: ${themeGet("colors.grey150")};
`

const TextWithEllipsis = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 12ch;
`

const settingRelevant = (setting) => Boolean(setting) && setting.id !== "all"

const shortTranslationKey = ({ translationKey }) =>
  `360_RECRUITER_INSIGHTS_BENCHMARK_PICKER_${translationKey}`

const benchmarkSettingsRelevant = ({ companySize, industry }) =>
  settingRelevant(companySize) || settingRelevant(industry)

const AllRecruiters = withi18n({})(({ t }) => (
  <Text data-testid="benchmarkSettingsAllRecruiters">
    {t("360_RECRUITER_INSIGHTS_BENCHMARK_PICKER_ALL_RECRUITERS")}
  </Text>
))

const ALL_TRANSLATION = "360_RECRUITER_INSIGHTS_BENCHMARK_PICKER_ALL"

const RelevantBenchmarkSettingsSummary = withi18n({})(({
  industry,
  companySize,
  t,
}) => {
  const industryTranslationKey = settingRelevant(industry)
    ? industry.translationKey
    : ALL_TRANSLATION
  const companySizeTranslationKey = settingRelevant(companySize)
    ? shortTranslationKey(companySize)
    : ALL_TRANSLATION

  return (
    <>
      <TextWithEllipsis>{t(industryTranslationKey)}</TextWithEllipsis>
      &nbsp;-&nbsp;
      <Text>{t(companySizeTranslationKey)}</Text>
    </>
  )
})

const Container = styled.div`
  display: flex;
  align-items: center;
`

const BenchmarkSettings = ({ benchmarkSettings }) => (
  <Container data-testid="benchmarkSettingsCollapsedPicker">
    <Separator />
    <TriggerIcon name="ProfileTrophy" width={size} height={size} />
    {benchmarkSettingsRelevant(benchmarkSettings) ? (
      <RelevantBenchmarkSettingsSummary
        industry={benchmarkSettings.industry}
        companySize={benchmarkSettings.companySize}
      />
    ) : (
      <AllRecruiters />
    )}
  </Container>
)

const DateRangePickerTrigger = ({ benchmarkSettings, rangeText }) => (
  <Container data-testid="dateRangePickerTrigger">
    <TriggerIcon name="NavigationEvents" width={size} height={size} />
    <Text>{rangeText}</Text>
    <BenchmarkSettings benchmarkSettings={benchmarkSettings} />
  </Container>
)

export default DateRangePickerTrigger
